import { normalizeMerchant } from './merchantName';

/** Мерчанты без логотипа и текстового названия на DefaultTemplate (imageWrapper). */
export const MERCHANTS_WITHOUT_BRANDING: readonly string[] = ['idp', 'championdx'];

/**
 * Пустое имя не входит в список — блок брендинга показывается (как раньше, fallback-текст).
 */
export const shouldShowMerchantBranding = (merchant?: string): boolean => {
  const normalized = normalizeMerchant(merchant);
  if (!normalized) {
    return true;
  }
  return !MERCHANTS_WITHOUT_BRANDING.includes(normalized);
};
